export default __webpack_public_path__ + "static/media/checkmark-1.0f718bcb.png";